<template>
    <v-container v-if="player">
        <!--        PLAYER DATA AND TOP STUFF -->
        <v-row>
            <v-col cols="12" sm="6">
                <v-row justify="center"
                       align="center"
                       :style="`height:${($vuetify.breakpoint.xsOnly)?200:400}px;`">
                    <v-col cols="12" class="text-center">
                        <v-avatar size="150px">
                            <img :src="player.info.profilepic"/>
                        </v-avatar>
                        <v-row>
                            <v-col
                               class="headline font-weight-light text-right"
                               cols="6"
                            >
                                <v-btn text @click="updatingvalues('firstname',player.info.firstname,'players','info')">
                                    {{player.info.firstname||'FirstName'}}
                                    <v-icon>{{icons.edit}}</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                class="headline font-weight-light text-left"
                                cols="6">
                                <v-btn text @click="updatingvalues('lastname',player.info.lastname,'players','info')">
                                    {{player.info.lastname||'LastName'}}
                                    <v-icon>{{icons.edit}}</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="12" v-if="!editlocked">
                                <Uploader  @newfiles="setProfilePic($event)" :limitone="true" :crop="true" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
            <!--PLAYER BODY MEAS LIST-->
            <v-col cols="12" sm="6">
                <v-card outlined>
                    <v-list>
                        <v-subheader inset>
                            {{sportcode}}
                        </v-subheader>

                        <v-list-item
                                :disabled="editlocked"
                                @click="updatingvalues('gradyear',player.info.gradyear,'players','info',null)">
                            <v-list-item-avatar>
                                <v-icon color="awesome">mdi-school-outline</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{player.info.gradyear}}
                                </v-list-item-title>
                                <v-list-item-subtitle>Grad Year</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="plrl" :disabled="editlocked"
                                     @click="updatingvalues('email',player.info.email,'players','info',null)">
                            <v-list-item-avatar>
                                <v-icon color="awesome">{{icons.email}}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{player.info.email}}</v-list-item-title>
                                <v-list-item-subtitle>Email</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action v-if="player.info.email && !player.info.emailverified">
                                <v-btn icon @click.stop="emailverifydialog=true">
                                    <v-icon>{{icons.info}}</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item class="plrl" :disabled="editlocked"
                                     @click="updatingvalues('cell',player.info.cell,'players','info',null)">
                            <v-list-item-avatar>
                                <v-icon color="awesome">{{icons.call}}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{player.info.cell}}</v-list-item-title>
                                <v-list-item-subtitle>Cell</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="plrl" :disabled="editlocked"
                                     @click="updatingvalues('about',player.info.about, 'players','info',null)">
                            <v-list-item-avatar>
                                <v-icon color="awesome">{{icons.info}}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>About Me</v-list-item-title>
                                <v-list-item-subtitle>{{player.info.about}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="plrl" :disabled="editlocked"
                                     @click="updatingvalues('sandrecruit',player.info.sandrecruit, 'players','info',null)"
                                     v-if="(sportcode=='beach')">
                            <v-list-item-avatar>
                                <v-icon color="awesome">S</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{player.info.sandrecruit}}</v-list-item-title>
                                <v-list-item-subtitle>Sandrecruit</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="plrl" :disabled="editlocked"
                                     @click="updatingvalues('instagram',player.info.instagram, 'players','info',null)"
                                     v-if="(sportcode==='beach')">
                            <v-list-item-avatar>
                                <v-icon color="awesome">mdi-instagram</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{player.info.instagram}}</v-list-item-title>
                                <v-list-item-subtitle>Instagram</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="plrl" :disabled="editlocked" v-on:click="handleactive($event)">
                            <v-list-item-action>
                                <v-progress-circular
                                        v-if="handlingactive"
                                        indeterminate
                                        color="primary"
                                ></v-progress-circular>
                                <v-switch
                                        v-else
                                        v-model="activeprofile"
                                        color="primary"
                                ></v-switch>
                            </v-list-item-action>
                            <v-list-item-content>
                                {{this.activeprofile===true?'Active - This will show publicly':'Not Active - not visible to public'}}
                            </v-list-item-content>
                        </v-list-item>

                    </v-list>
                </v-card>
            </v-col>
        </v-row>

        <!--CLUB AND COLLEGE BLOCK-->
        <v-row v-if="1===2">
            <v-col cols="4" v-if="displayclub && displayclub.partkey != 'unaffl'">
                <div @click="handleclubdialog(), getclubs()">
                    <img v-if="displayclub.logo" :src="displayclub.logo" height="40"/>
                    <h3 class="font-weight-thin">{{displayclub.fullname}}</h3>
                </div>
            </v-col>
            <v-col cols="4" v-else>
                <v-btn text @click="clubdialog = true, getclubs()">
                    <v-icon :small="$vuetify.breakpoint.smAndUp" class="mr-1">mdi-tshirt-crew-outline</v-icon>
                    <span class="hidden-xs-only">Unaffiliated</span>
                </v-btn>
            </v-col>

            <!--COMMITED-->
            <v-col cols="4" v-if="committed" class="text-center">
                <v-badge right>
                    <v-icon
                            slot="badge"
                            class="white--text"
                            @click.native="decommitdialog = true"
                    >
                        {{icons.close}}
                    </v-icon>
                    <div @click="commitdialog = true">
                        <img :src="displaycommit.img" height="50"/>
                        <h3 class="font-weight-thin">{{displaycommit.name}}</h3>
                    </div>
                </v-badge>
            </v-col>
            <v-col cols="4" class="text-center" v-else>
                <v-btn text block @click="commitdialog = true">
                    <v-icon :small="$vuetify.breakpoint.smAndUp" class="mr-1">mdi-school-outline</v-icon>
                    <span class="hidden-xs-only">Not Committed</span>
                </v-btn>
            </v-col>

            <v-col cols="4" class="text-right">
                <v-btn text @click="geteditors()">
                    <v-icon :small="$vuetify.breakpoint.smAndUp">{{icons.edit}}</v-icon>
                    <span class="hidden-xs-only">Profile Editors</span>
                </v-btn>
            </v-col>

        </v-row>


        <!--BOTTOM PANEL BUTTONS-->
        <v-card color="awesome">
            <v-row justify="center" class="py-0">

                <v-col cols="4" class="text-center">
                    <v-btn outlined fab color="white" @click="measurementdialog = true" class="bfab">
                        <v-icon>mdi-chart-bar</v-icon>
                    </v-btn>
                    <p class="white--text">Msments</p>
                </v-col>


                <v-col cols="4" class="text-center">
                    <v-btn v-bind:disabled="!player.info.emailverified" outlined fab color="white"
                           @click.native="sharedialog = true" class="bfab">
                        <v-icon>{{icons.email}}</v-icon>
                    </v-btn>
                    <p class="white--text">Send</p>
                </v-col>


                <v-col cols="4" class="text-center">
                    <v-btn outlined fab color="white" @click="metricsdialogshow" class="bfab">
                        <v-icon>{{icons.checkon}}</v-icon>
                    </v-btn>
                    <p class="white--text">Metrix</p>
                </v-col>


                <v-col cols="4" class="text-center">
                    <v-btn outlined fab color="white" class="bfab"
                           @click="achievementdialog=true, handleachievements('get')">
                        <v-icon>mdi-trophy-award</v-icon>
                    </v-btn>
                    <p class="white--text">Achievements</p>
                </v-col>


                <v-col cols="4" class="text-center">
                    <v-btn outlined fab color="white" class="bfab" @click="scheduledialog=true, getevents()">
                        <v-icon class="flip">{{icons.calendar}}</v-icon>
                    </v-btn>
                    <p class="white--text">Schedule</p>
                </v-col>


                <v-col cols="4" class="text-center">
                    <v-btn outlined fab disabled color="white" class="bfab" :to="'/playerprofile/'+ player.partkey">
                        <v-icon>mdi-iframe-outline</v-icon>
                    </v-btn>
                    <p class="white--text">My Page</p>
                </v-col>

                <v-col cols="4" class="text-center" v-if="org" >
                    <v-btn outlined fab color="white" class="bfab" v-if="permissions.includes('*') || permissions.includes('financial')" >
                        <SetPlayerBilling  color="white" :player="player" />
                    </v-btn>
                    <p class="white--text">Payer</p>
                </v-col>


                <v-col cols="4" class="text-center">
                    <v-btn outlined fab color="white" class="bfab" @click="getnotes()">
                        <v-icon>{{icons.bookmark}}</v-icon>
                    </v-btn>
                    <p class="white--text">Notes</p>
                </v-col>


            </v-row>
        </v-card>


        <!--  DIALOGS  -->
        <v-row>

            <v-col cols="6">
                <v-btn block outlined large @click.native="loadvideos()"
                       color="awesome" class="white--text">
                    <v-icon>mdi-movie</v-icon>
                    Videos of {{player.info.firstname||''}}
                </v-btn>
            </v-col>

            <v-col cols="6">
                <v-btn block outlined large @click.native="profilevideodialog = true"
                       color="awesome" class="white--text">
                    <v-icon>mdi-video</v-icon>
                    Profile Videos
                </v-btn>
            </v-col>

        </v-row>

        <!--SHARE-->
        <v-dialog v-model="sharedialog"
                  fullscreen
                  transition="dialog-bottom-transition"
                  :overlay="false"
                  scrollable

        >
            <v-card text>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="sharedialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Share {{player.info.firstname||'Player'}}'s Profile</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>


                <v-card-text>
                    <Share
                            :player="player"
                            v-on:closeshare="closeShareDialog"
                    />
                </v-card-text>

                <v-card-actions>


                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--MEASUREMENTS DIALOG-->
        <v-dialog v-model="measurementdialog"
                  max-width="400"
                  :overlay="false"
                  scrollable

        >
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="measurementdialog = false" dark>
                        <v-icon>{{icons.close}}</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{player.info.firstname||'Player'}}'s Measurements</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-card-text>
                    <v-card outlined>
                        <v-list>
                            <v-list-item v-for="(v,n,i) in meas_model"
                                         v-bind:key="i"
                                         @click="updatingvalues(v.title, (player.sport[sport]['measurements'][v.title]||0), v.id, 'measurements', n)">
                                <v-list-item-content>
                                    {{v.title}}
                                </v-list-item-content>
                                <v-list-item-action>
                                    {{ player.sport[sport]['measurements'][v.title]||0 }}
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-card-text>

                <v-card-actions>

                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--UPDATER DIALOG-->
        <v-dialog
                v-model="updatedialog"
                max-width="400">
            <v-card>
                <v-card-title class="headline text-uppercase">{{activedataname}}</v-card-title>
                <v-card-text>
                    {{activedatavalue}}
                    <v-textarea
                            v-if="activedataname==='about'"
                            outlined
                            :label="activedataname"
                            v-model="activedatavalue"
                            class="input-group--focused"
                    ></v-textarea>
                    <v-text-field
                            outlined
                            v-else
                            :label="activedataname"
                            v-model="activedatavalue"
                            class="input-group--focused"
                    ></v-text-field>

                </v-card-text>
                <v-card-actions>
                    <v-btn color="awesome darken-1" text @click.native="updatedialog = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="awesome darken-1" text @click.native="update">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--UPDATER FOOT DIALOG-->
        <v-dialog v-model="updatefootmodal"
                  max-width="400"
        >
            <v-card>
                <v-card-title class="headline">{{activedataname}}</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-text-field
                                        outline
                                        value=""
                                        class="input-group--focused"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                        outline
                                        value=""
                                        class="input-group--focused"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click.native="updatefootmodal = false">Cancel</v-btn>
                    <v-btn color="green darken-1" text @click.native="update">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--METRIX DIALOG-->
        <Metrics ref="metrix" :player="player"></Metrics>

        <!--PROFILE VIDEO DIALOG-->
        <v-dialog v-model="profilevideodialog"
                  fullscreen
                  transition="dialog-bottom-transition"
                  :overlay="false"

                  v-resize="onResize"
        >

            <v-card text>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="profilevideodialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{player.info.firstname||'Player'}}'s Profile Videos</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <v-card-text>
                    <v-flex xs12 sm6 offset-sm3>
                        <h3>These videos will show up on your public profile page</h3>
                    </v-flex>
                    <v-flex xs12 sm6 offset-sm3>
                        <v-card v-for="(v, i ) in player.sport[sport]['profilevideos']" :key="v.sortkey" class="mb-2">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{v.videotitle}} </h3>
                                    <div><small>{{v.videome}}</small></div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <video style="width:100%;" preload="auto" class="videoplayer" transition="rotate"
                                       controls>
                                    <source :poster="v.thumb" :src="v.url720p" type="video/mp4">
                                </video>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn text small @click="removevideofromprofile(v.sortkey)">
                                    <v-icon>indeterminate_check_box</v-icon>
                                    remove
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-card-text>

                <v-card-text>
                    <v-flex xs12 sm12 md6 offset-md3 v-if="!playerembedid">
                        <div :style="{ 'width': playerwidth + 'px' }">
                            <h1>
                                <v-icon large color="red darken-2">fab fa-youtube</v-icon>
                                Youtube Embed
                            </h1>
                            <p class="subheading">
                                Youtube -> Click SHARE -> COPY - past URL below, we will attempt to import the link
                            </p>

                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md6 offset-md3>
                        <youtube v-if="playerembedid" :player-width="playerwidth" :player-height="playerheight"
                                 :video-id="playerembedid"></youtube>
                        <v-text-field
                                :style="{ 'width': playerwidth + 'px' }"
                                @change="setyoutube()"
                                outline
                                label="Youtube Video ID"
                                v-model="playerembedid"
                                append-icon="fab fa-youtube"
                        ></v-text-field>
                    </v-flex>
                </v-card-text>

            </v-card>
        </v-dialog>


        <!--VIDEOS DIALOG-->
        <v-dialog v-model="videosdialog"
                  fullscreen
                  transition="dialog-bottom-transition"
                  :overlay="false"
                  scrollable
        >
            <v-card>
                <v-card-title color="awesome">
                    <v-btn icon @click.native="videosdialog = false" dark>
                        <v-icon>{{icons.close}}</v-icon>
                    </v-btn>
                    <v-toolbar-title>Videos tagged with {{player.info.firstname||'Player'}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <Videos :activeplayer="player"/>
                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>

        </v-dialog>


        <v-dialog v-model="emailverifydialog"
                  fullscreen
                  transition="dialog-bottom-transition"
                  :overlay="false"
                  scrollable

        >
            <v-card text>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="emailverifydialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Verify {{player.info.email}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <p>
                        We use Amazon Web Services to send "share" emails. And we hate spam.
                        You will need to verify ownership of the email address before you can send emails with
                        the app. This is DIFFERENT than the link sent to register.
                    </p>
                    <ul>
                        <li>
                            1.) Click 'VERIFY NOW' to send a verification email to the player-email listed above. It
                            will come from Amazon Web Services
                        </li>
                        <li>
                            2.) Click the link in the email, you will be re-directed to Amazon Web Services verification
                            page.
                        </li>
                        <li>
                            3.) Click 'CHECK VERIFICATION STATUS' to confirm
                        </li>
                        <li>
                            4.) That's it! In a few minutes your email will be ready to use!
                        </li>
                    </ul>
                    <v-btn text @click.native="verifyemail(player.info.email)">verify now</v-btn>
                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="emailconfirmed" max-width="500px">
            <v-card>
                <v-img
                        class="white--text"
                        src="/static/20171223_133011.jpg"
                        height="300px"
                >
                    <v-container fill-height fluid>
                        <v-layout fill-height>
                            <v-flex xs12 align-end flexbox>
                                <span class="headline">Rock ON!</span>
                            </v-flex>
                        </v-layout>
                    </v-container>

                </v-img>
                <v-card-text>
                    <h4>
                        Your email has been confirmed!
                    </h4>
                    <p>
                        Now go! <br/>Send one! <br/>To a real coach!
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text="text" outline
                           @click.native="emailconfirmed = false; "
                    >
                        OK! I'm ON it!
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="clubdialog" max-width="500px">
            <v-card>
                <v-card-title>
                    Request to join a supported club
                </v-card-title>
                <v-card-text>
                    <v-row v-for="c in clubs" :key="c.name" class="py-0">
                        <v-col cols="6" class="py-0">
                            <v-btn small outlined block @click="requestjoinclub(c)">
                                Join
                                {{c.name}}
                            </v-btn>
                        </v-col>
                        <v-col cols="3" class="py-0">

                        </v-col>
                        <v-col cols="3" class="py-0">
                            <img :src="c.logo" height="20"/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="clubdialog = false, clubconfirmdialog=false,requestedclub='' ">Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--CLUB DIALOG CONFIRM-->
        <v-dialog v-model="clubconfirmdialog" max-width="400px">
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <div class="subheading">
                                <img :src="requestedclub.logo" height="40"/>
                                We will send a request for
                                {{player.info.firstname}}
                                to join {{requestedclub.name}} ?
                            </div>
                            <div class="caption">
                                Note: this profile can only belong to 1 club at a time. Any videos or data owned by the
                                club will not follow the profile
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="clubdialog = false, clubconfirmdialog=false,requestedclub='' ">Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined
                           @click="sendrequest(requestedclub.partkey, player.partkey, 'join', player.info, 'Request to join '+requestedclub.name, requestedclub.logo )">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--COMMIT DIALOG-->
        <v-dialog v-model="commitdialog" max-width="300px" scrollable>
            <v-card>
                <v-card-text>
                    <v-text-field
                            label="College Name"
                            v-model="committed"
                            :value="committed==false?'':committed"
                            outline
                            @keyup="searchcommit()"
                    ></v-text-field>


                    <v-list>
                        <v-list-item
                                v-for="(s,i) in searchresults"
                                :key="i.id"
                                @click="setcommit(s.partkey)"
                        >

                            <v-list-item-content>
                                <v-list-item-title v-text="s.name"></v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-avatar>
                                <img :src="s.img">
                            </v-list-item-avatar>

                        </v-list-item>
                    </v-list>

                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="commitdialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="decommitdialog" max-width="500px">
            <v-card>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 class="font-weight-thin">
                            This will remove<br/>
                            <img :src="displaycommit.img" height="50"/>
                            <span class="title font-weight-thin">{{displaycommit.name}}</span><br/><br/>
                            from your active profile
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="red darken-4" @click="decommit()">Continue</v-btn>
                    <v-btn text color="info" @click="decommitdialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="editorsdialog" max-width="400">
            <v-card>
                <v-card-title>Add Editor</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" v-if="neweditor!=''">
                            {{neweditor.user}}
                        </v-col>
                        <v-col cols="12" v-if="!founduser">
                            <v-text-field
                                    label="New Editor"
                                    placeholder="Enter username of new editor"
                                    v-model="neweditor"
                                    outlined
                                    :append-outer-icon="icons.search"
                                    @click:append-outer="findUser()"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" v-if="founduser" class="title">{{founduser.username}}</v-col>
                        <v-col cols="5" v-if="founduser" class="title">{{founduser.email}}</v-col>
                        <v-col cols="3">
                            <v-progress-circular
                                    class="pl-2"
                                    v-if="searchinguser"
                                    indeterminate
                                    color="primary"
                            ></v-progress-circular>
                            <v-btn v-if="founduser" outlined @click="handleeditor(founduser.sub,'add')">Add</v-btn>
                            <v-btn v-if="founduser" outlined @click="neweditor='',founduser=false,searchinguser=false">
                                Search Again
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            {{player.info.firstname||'FirstName'}} {{player.info.lastname||'LastName'}}'s card is shared
                            with the following users. They can view and edit the profile card.
                            <v-list>
                                <v-list-item v-for="(e,i) in editors" :key="i">
                                    <v-list-item-content>
                                        {{e.username}}
                                    </v-list-item-content>
                                    <v-list-item-content>
                                        {{e.email}}
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-list-item-content v-if="$store.state.activeplayer.canedit.includes(i)">
                                            OWNER
                                        </v-list-item-content>
                                        <v-list-item-content v-else-if="$store.state.token.sub==i">
                                            YOU
                                        </v-list-item-content>
                                        <v-btn v-else text @click="handleeditor(i,'remove')">remove</v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="awesome"
                           @click="editorsdialog=false,neweditor='',founduser=false,searchinguser=false">Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--SCHEDULE DIALOG-->
        <v-dialog v-model="scheduledialog"
                  :overlay="false"
                  scrollable
                  fullscreen
                  fixed
        >
            <v-card text>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="scheduledialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{player.info.firstname||'Player'}} - Events</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn text @click="searchscheduledialog=true">Add Date</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>

                    <v-layout row wrap>
                        <v-list three-line>
                            <template v-for="(e,i) in myevents">
                                <v-list-item
                                        :key="e.id">
                                    <v-list-item-action>
                                        <v-btn icon ripple @click="confirmeventremove(e)">
                                            <v-icon color="orange lighten-1">fas fa-minus</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{new Date(e.date).toLocaleDateString("en-US")}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>{{e.name}} | {{e.location}}
                                            <br/><a :href="e.url" target="_blank">{{e.url}}</a>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-layout>

                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>


        <!--SCHEDULE DIALOG-->
        <v-dialog v-model="searchscheduledialog"
                  :overlay="false"
                  scrollable
        >
            <v-card text>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="searchscheduledialog = false, searchstring='', events=[]" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{player.info.firstname||'Player'}} - Events</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm6 md3>
                            <v-text-field
                                    label="Event Name or Location"
                                    placeholder="Search"
                                    v-model="searchstring"
                                    @keyup="searchevent()"
                                    outline
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                        <v-list three-line>
                            <template v-for="(e,i) in events">
                                <v-list-item
                                        :key="e.id">
                                    <v-list-item-action>
                                        <v-btn icon ripple @click="confirmeventadd(e)">
                                            <v-icon color="green lighten-1">fas fa-plus</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{e.name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{e.location}} | {{new
                                            Date(e.date).toLocaleDateString("en-US")}}
                                            <br/><a :href="e.url" target="_blank">{{e.url}}</a>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-layout>

                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="confirmevent">
            <v-card>
                <v-card-text>
                    would you like to add
                    <div class="subheading">
                        {{activeevent.name}}
                    </div>
                    on
                    <div class="subheading">
                        {{new Date(activeevent.date).toLocaleDateString("en-US")}}
                    </div>
                    to your upcoming play?
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="handleevent('addto')">Yes</v-btn>
                    <v-btn outlined @click="confirmevent=false,activeevent=''">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="confirmeventr">
            <v-card>
                <v-card-text>
                    Remove
                    <div class="subheading">
                        {{activeevent.name}}
                    </div>
                    on
                    <div class="subheading">
                        {{new Date(activeevent.date).toLocaleDateString("en-US")}}
                    </div>
                    from your event - play?
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="handleevent('delete')">Yes</v-btn>
                    <v-btn outlined @click="confirmeventr=false,activeevent=''">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--ACHEIVEMENT DIALOG-->
        <v-dialog v-model="achievementdialog"
                  :overlay="false"
                  scrollable
                  fullscreen
                  fixed
        >
            <v-card text>
                <v-toolbar style="flex: 0 0 auto;" dark color="awesome">
                    <v-btn icon @click.native="achievementdialog = false" dark>
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{player.info.firstname||'Player'}} - Achievements</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn text @click="hanldeachievementdialog=true">Add Item</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>

                    <v-layout row wrap>
                        <v-list three-line>
                            <template v-for="(e,i) in myachievements">
                                <v-list-item
                                        :key="e.id">
                                    <v-list-item-action>
                                        <v-btn icon ripple
                                               @click="newachievement=e, confirmdeleteachievementdialog=true">
                                            <v-icon color="orange lighten-1">fas fa-minus</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{e.name}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>{{e.description}}
                                            <v-btn icon small @click="newachievement=e, hanldeachievementdialog=true">
                                                <v-icon>fas fa-edit</v-icon>
                                            </v-btn>
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-layout>

                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="hanldeachievementdialog">
            <v-card>
                <v-card-text>
                    <v-flex row wrap>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="Outline"
                                    placeholder="Placeholder"
                                    outline
                                    v-model="newachievement.name"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-textarea
                                    outline
                                    label="Description"
                                    v-model="newachievement.description"
                            ></v-textarea>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="handleachievements('add')">Save</v-btn>
                    <v-btn outlined
                           @click="hanldeachievementdialog=false,newachievement.name='', newachievement.description=''">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="confirmdeleteachievementdialog">
            <v-card>
                <v-card-text>
                    Remove {{newachievement.name}} from your achievements?
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="handleachievements('delete')">Continue</v-btn>
                    <v-btn outlined @click="confirmdeleteachievementdialog=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="requestdialog" v-if="myrequests">
            <v-card>
                <v-card-text>
                    <v-list three-line>
                        <template v-for="(r,i) in myrequests">
                            <v-list-item
                                    :key="r.id">
                                <v-list-item-action>
                                    <v-list-item-avatar>
                                        <img :src="r.image">
                                    </v-list-item-avatar>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{new Date(r.createdAt).toLocaleDateString("en-US")}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{r.description}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined @click="requestdialog=false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--NOTEPAD DIALOG-->
        <v-dialog :fullscreen="$vuetify.breakpoint.name==='xs'" v-model="notebookdialog" scrollable max-width="450">
            <v-card>
                <v-card-title>
                    Notebook
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                    <Notepad
                            :api="$store.state.url"
                            :videourl="$store.state.videourl"
                            :bookkey="$route.params.uuid"
                            :title="player.info.firstname+' '+player.info.lastname+' Notes'"
                            path="tag"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="notebookdialog=false">close</v-btn>
                    <v-spacer></v-spacer>
                    <AddNote
                            :tag="player.partkey"
                            :orgkey="org.partkey"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="addnotedialog">
            <v-card>
                <v-card-title>Add Note</v-card-title>
                <v-card-text>
                    <v-flex row wrap>
                        <v-flex xs12>
                            <v-textarea
                                    label="Outline"
                                    placeholder="Placeholder"
                                    outline
                                    v-model="notetext"
                            ></v-textarea>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="savenote()">save</v-btn>
                    <v-btn text @click="addnotedialog=false">cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



    </v-container>
</template>

<script>
  import mm from '@/views/a4l/MeasurementModel.js'
  import Share from '@/views/a4l/Share'
  import Metrics from '@/views/a4l/Metrics'
  import {
    mapState,
    mapActions
  } from 'vuex'
  import SetPlayerBilling from '@/views/a4l/SetPlayerBilling';

  export default {
    name: 'Player',
    components: {
      SetPlayerBilling,
      Uploader: () => import('@/components/uploader/UploaderCropper'),
      Notepad: () => import('@/views/a4l/Notepad'),
      AddNote: () => import('@/views/a4l/AddNote'),
      Share,
      Metrics,
      Videos: () => import('@/views/a4l/Videos')
    },
    data() {
      return {
        player: false,
        sport: this.$store.state.sportcode,
        dialog: false,
        msmt: '',
        updatedialog: false,
        updatefootmodal: false,
        activedataname: '',
        activedatavalue: '',
        activetable: '',
        activeunits: '',
        meas_model: '',
        updatecol: '',// TODO make an object activemeas{code,id}
        activemeasid: '',
        measurementdialog: false,
        bottombuttons: true,
        profilevideodialog: false,
        videosdialog: false,
        sharedialog: false,
        emailverified: false,
        emailverifydialog: false,
        verifyableemail: false,
        emailconfirmed: false,
        activeprofile: false,
        handlingactive: false,
        editlocked: true,
        clubs: [],
        clubdialog: false,
        club: 'CLUB',
        clubconfirmed: false,
        displayclub: false,
        tmpclub: false,
        committed: false,
        searchresults: false,
        displaycommit: false,
        commitdialog: false,
        decommitdialog: false,
        playerwidth: 400,
        playerheight: 390,
        playerembedid: '',
        editorsdialog: false,
        editors: false,
        neweditor: '',
        founduser: false,
        searchinguser: false,
        scheduledialog: false,
        searchstring: '',
        neweventname: '',
        neweventurl: '',
        events: [],
        myevents: [],
        activeevent: '',
        confirmevent: false,
        confirmeventr: false,
        searchscheduledialog: false,
        achievementdialog: false,
        myachievements: [],
        hanldeachievementdialog: false,
        newachievement: {
          name: '',
          description: '',
          id: false
        },
        confirmdeleteachievementdialog: false,
        clubdialogOLD: false,
        clubconfirmdialog: false,
        requestedclub: '',
        myrequests: false,
        requestdialog: false,
        notes: [],
        notetext: '',
        notebookdialog: false,
        addnotedialog: false
      }
    },
    computed: {
      ...mapState(['org', 'icons','permissions']),
      sportcode() {
        return this.$route.params.sportcode
      }
    },
    watch: {
      player(n, o) {
        if (n) {
          this.committed = this.player.sport[this.sportcode].committed;
          this.editlocked = false;// this.player.editlocked;
          this.activeprofile = this.player.sport[this.sportcode].active;
          this.playerembedid = this.player.sport[this.sportcode].youtubevideo;
          this.displayclub = this.player.displayclub
        }
      },
      committed(n, o) {
        if (n)
          this.getcollege(n)
      },
      displayclub(n) {
        console.log('Display Club:', n)
        if (n) {
          this.getclub(this.player.sport[this.sportcode].club.partkey)
        }
      }
    },
    created() {
      this.selectPlayer()
    },
    mounted() {
      this.playerwidth = ((window.innerWidth - 32) > 640) ? 640 : (window.innerWidth - 32)
      this.playerheight = this.playerwidth * .609 //ratio of 390/640 - height:640 width:390
      this.meas_model = mm[this.sportcode];
    },
    methods: {
      ...mapActions(['get', 'post', 'put']),
      async selectPlayer() {
        let p = await this.get({path: 'api/profilesv2/pv/' + this.$route.params.playerkey + '/' + this.sportcode})
        console.log(p)
        this.player = p
        // em.$store.commit('activeplayer',data);
        // em.$store.commit('videogroup',uuid);
        // em.$router.push({path:'/player/'+uuid});
      },
      async findUser() {
        if (this.neweditor == '') return;
        this.searchinguser = !true
        let response = await this.get({path: 'api/playerv2/getuser/' + this.neweditor})
        this.searchinguser = false
        if (response.code) {
          return
        }
        response.UserAttributes.forEach(function (d) {
          if (d.Name === 'sub') {
            this.founduser.sub = d.Value
          }
          if (d.Name === 'email') {
            this.founduser.email = d.Value
          }
        })
        this.founduser = {
          username: response.Username
        }
      },
      handleeditor(key, action) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/handleeditors',
          method: 'PUT',
          data: {
            partkey: this.player.partkey,
            info: this.player.info,
            sport: this.sportcode,
            key: key,
            action: action,
            canedit: this.player.sport[this.sportcode].canedit
          }
        }
        //PUT for change record
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.neweditor = '',
              em.founduser = false,
              em.searchinguser = false
            em.editorsdialog = false
            em.refresh()
          })
      },
      async geteditors() {
        let data = {
          editors: this.player.sport[this.sportcode].canedit
        }
        let response = await this.post({path: 'api/playerv2/profileeditors', body: data})
        console.log(response)
        this.editors = response
        this.editorsdialog = true;
      },
      getclubs() {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/club/all/beach',
          method: 'GET'
        }
        //PUT for change record
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.clubs = data
          })
      },
      loadvideos() {
        //SET VIDEO GROUP KEY, THE DIRECT TO THE VIDEOS PAGES, IT WILL LOAD THE VIDEOS BASED ON THE KEY
        this.videosdialog = true;
      },
      updatingvalues(name, value, mid, code, mmkey) {
        this.activeunits = ''
        if (code == 'measurements') {
          this.activeunits = mm[this.sportcode][mmkey].units;
        }
        if (this.editlocked) return;
        this.activedataname = name;
        this.activedatavalue = value
        if (code === 'measurements' && mm[this.sportcode][mmkey].units === 'ft') {
          this.updatedialog = true;

        } else {
          this.updatedialog = true;
        }
        this.updatecol = code;
        this.activemeasid = mid;
      },
      update() {
        // replace spaces with underscores to get the db.
        let a = this.activedataname.replace(' ', '_')
        let data = {
          partkey: this.player.partkey,
          sport: this.sportcode,
          col: this.updatecol,
          attribute: this.activedataname,
          value: this.activedatavalue
        }
        this.put({path: 'api/profilesv2', body: data})
        this.updatedialog = false;
        if (this.updatecol === 'measurements') {
          this.player.sport[this.sport][this.updatecol][this.activedataname] = this.activedatavalue;
        } else {
          this.player[this.updatecol][this.activedataname] = this.activedatavalue;
        }
      },
      removevideofromprofile(sortkey) {
        //add video to player profile
        var em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/profilevideo',
          method: 'POST',
          data: {
            partkey: this.player.partkey,
            playerurl: this.player.partkey,
            sport: this.sportcode,
            videoname: sortkey
          }
        }

        this.$store.dispatch('fetch', args)
          .then(function (data) {
            delete em.player.sport[this.sportcode].profilevideos[sortkey];
            em.profilevideodialog = false;
          }).catch(function (e) {
          console.log(e);
        })
      },
      metricsdialogshow() {
        var em = this;
        let p1 = this.$refs.metrix.loademails();
        let p2 = this.$refs.metrix.videoviews();
        let p3 = this.$refs.metrix.pageviews();
        Promise.all([p1, p2, p3]).then(function () {
          //execute what i might need here
          em.$store.commit('metricsdialogshow', true);
        });
      },
      verifyemail(eml) {
        let em = this
        let args = {
          url: this.$store.state.url + 'api/share/verifyemail',
          method: 'POST',
          data: {
            email: eml
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            alert('A verification email has been sent');
            em.emailverifydialog = false;
          }).catch(function (e) {
        })
      },
      checkverificationstatus(eml) {
        var em = this;
        let args = {
          url: this.$store.state.url + 'api/share/checkverifiedemails',
          method: 'POST',
          data: {
            partkey: em.player.partkey,
            email: eml
          }
        }

        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data);
            if (data.verified) {
              em.emailverified = true;
              em.emailconfirmed = true;
              let data = this.player;
              data.info.emailverified = true;
              //em.$store.commit('activeplayer', data);
            } else {
              //handle error
            }
          }).catch(function (e) {
          console.log(e);
        })
      },
      async handleactive(event) {
        //show on publicprofile page or not
        let data = {
          active: this.activeprofile,
          partkey: this.player.partkey,
          sport: this.sport,
          club: this.displayclub.name,
          firstname: this.player.info.firstname,
          lastname: this.player.info.lastname,
          gradyear: this.player.info.gradyear,
          profilepic: this.player.info.profilepic
        }
        this.handlingactive = true
        let response = await this.put({path: 'api/playerv2/handleactive', body: data})
        this.handlingactive = false //this is the spinner
      },
      closeShareDialog() {
        this.sharedialog = false;
      },
      handleclubdialog() {
        //if(this.editlocked==true)return;
        this.tmpclub = this.displayclub.name
        this.clubdialog = true
      },
      handleclub() {
        this.displayclub = false
        let updated = this.player.sport[this.sportcode]
        updated.club = {
          partkey: this.club,
          confirmed: false
        }
        let data = {
          partkey: this.player.partkey,
          sport: 'beach',
          updated: updated,
          oldclub: this.tmpclub,
          grad: this.player.info.gradyear,
          fname: this.player.info.firstname,
          lname: this.player.info.lastname,
          profilepic: this.player.info.profilepic
        }
        this.put({path: 'api/playerv2/club', body: data})
        this.clubdialog = false
        this.getclub(this.club)
      },
      requestjoinclub(c) {
        console.log(c)
        this.clubconfirmdialog = true
        this.requestedclub = c
      },//todo get players existing club before sending request... hackable
      sendrequest(to, from, code, data, descrip, image) {
        console.log((to, from, code, data, descrip, image))
        data.oldclub = this.displayclub.name || null;
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/sendrequest',
          method: 'POST',
          data: {
            to: to,
            from: from,
            code: code,
            data: data,
            description: descrip,
            image: image
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (d) {
            em.clubconfirmdialog = false
            em.clubdialog = false
            em.getrequests()
          }).catch(function (e) {
          console.log(e)
        });
      },
      getrequests() {
        this.myrequests = this.get({path: 'api/event/getrequests/' + this.player.partkey})
      },
      async getclub(partkey) {
        let em = this;
        this.displayclub = await this.get({path: 'api/playerv2/playerclub/' + partkey})
      },
      searchcommit() {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/searchcollege/' + em.committed,
          method: 'GET'
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data)
            em.searchresults = data
          }).catch(function (e) {
          console.log(e)
        });
      },
      setcommit(partkey) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/setcommit/',
          method: 'POST',
          data: {
            sport: this.sport,
            playerpartkey: this.player.partkey,
            collegepartkey: partkey,
            committed: 1
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.searchresults = false
            em.getcollege(partkey)
            em.commitdialog = false
            let d = this.player;
            d.sport[em.sport].committed = partkey
            em.$store.commit('activeplayer', d);
          }).catch(function (e) {
          console.log(e)
        });
      },
      decommit() {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/decommit/',
          method: 'POST',
          data: {
            sport: this.sport,
            playerpartkey: this.player.partkey,
            committed: 0
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data)
            em.committed = false
            em.decommitdialog = false
            let d = this.player;
            delete d.sport[em.sport].committed
            em.$store.commit('activeplayer', d)
          }).catch(function (e) {
          console.log(e)
        });
      },
      getcollege(partkey) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/college/' + partkey,
          method: 'GET'
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.displaycommit = data
          }).catch(function (e) {
          console.log(e)
        });
      },
      onResize() {
        this.windowSize = {x: window.innerWidth, y: window.innerHeight}
        this.playerwidth = ((window.innerWidth - 32) > 640) ? 640 : (window.innerWidth - 32);
        this.playerheight = this.playerwidth * .609
      },
      setyoutube() {
        let em = this;
        this.playerembedid = this.playerembedid.replace('https://youtu.be/', '')
        let args = {
          url: this.$store.state.url + 'api/video/saveyoutubeembed',
          method: 'POST',
          data: {
            sport: this.sport,
            playerpartkey: this.player.partkey,
            youtubeid: this.playerembedid
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            let d = this.player;
            d.sport[em.sport].youtubevideo = em.playerembedid
            em.$store.commit('activeplayer', d);
          }).catch(function (e) {
          console.log(e)
        });
      },
      refresh() {
        let em = this;
        setTimeout(function () {
          em.$methods.getPlayer(this.player.partkey)
        }, 1000)
      },
      schedule(action) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/playerv2/schedule',
          method: 'POST',
          data: {
            player: this.player.partkey,
            action: action
          }
        }
        //PUT for change record
        this.events.push({name: this.neweventname, url: this.neweventurl})
        this.neweventname = '';
        this.neweventurl = '';
//                this.$store.dispatch('fetch',args)
//                .then(function(data){console.log(data)})
      },
      searchevent() {
        if (this.searchstring == '') {
          return
        }
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/handleevent',
          method: 'POST',
          data: {
            action: 'search',
            searchstring: this.searchstring
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.events = data
          })
      },
      confirmeventadd(e) {
        this.activeevent = e
        this.confirmevent = true
      },
      confirmeventremove(e) {
        this.activeevent = e
        this.confirmeventr = true
      },
      handleevent(action) {
        console.log(action)
        //if(this.searchstring==''){return}
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/handleevent',
          method: 'POST',
          data: {
            action: action,
            player: this.player.partkey,
            eventid: this.activeevent.id,
            searchstring: this.searchstring
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            console.log(data)
            em.activeevent = false;
            em.searchstring = '';
            em.confirmevent = false;
            em.confirmeventr = false;
            em.events = [];
            em.searchscheduledialog = false;
            em.getevents('get');
          })
      },
      getevents(action) {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/event/handleevent',
          method: 'POST',
          data: {
            action: 'get',
            player: this.player.partkey
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.myevents = data
          })
      },
      handleachievements(action) {
        let em = this;
        if (action == 'add' && this.newachievement.id) {
          action = 'update'
        }
        let args = {
          url: this.$store.state.url + 'api/event/achievements',
          method: 'POST',
          data: {
            action: action,
            name: this.newachievement.name,
            description: this.newachievement.description,
            player: this.player.partkey,
            id: this.newachievement.id
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.hanldeachievementdialog = false;
            em.newachievement = {
              name: '',
              description: '',
              id: false
            }
            em.confirmdeleteachievementdialog = false
            if (action == 'get') {
              em.myachievements = data
            } else {
              em.handleachievements('get')
            }
          })
      },
      getnotes() {
        let em = this;
        let args = {
          url: this.$store.state.url + 'api/notes/tag/' + this.player.partkey,
          method: 'GET'
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.notes = data;
            em.notebookdialog = true;
          }).catch(function (e) {
          console.log(e);
        });
      },
      savenote() {
        var em = this;
        let args = {
          url: this.$store.state.url + 'api/notes/savenote',
          method: 'put',
          data: {
            type: 'text',
            tag: this.player.partkey,
            orgkey: this.$store.state.appdata.a4lorg.partkey,
            body: this.notetext
          }
        }
        this.$store.dispatch('fetch', args)
          .then(function (data) {
            em.addnotedialog = false;
            em.notetext = '';
          }).catch(function (e) {
          console.log(e);
        });
      },
      setProfilePic(e){
        console.log('E',e)
        let base = 'https://orgbucket-'+this.org.partkey+'.s3-us-west-2.amazonaws.com/'
        let pic = base + e[0].Key
        this.updatecol = 'info'
        this.activedataname = 'profilepic'
        this.activedatavalue = pic
        this.update()
      }
    }
  }



</script>

<style scoped>
    .hf {
        font-weight: 500;
        font-size: 1.5em;
        display: inline-block;
    }

    .hf2 {
        font-weight: 300;
        display: inline-block;
    }

    .infobox {
        border: solid thin #555555;
        border-radius: 3px;
        padding: 5px;
        display: inline-block;
        width: 60px;
        text-align: left;
        float: right;
    }

    .plrl {
        width: 100%;
    }

    .bfab {
        margin-bottom: 10px;
    }

    .flip {
        transform: scaleX(-1);
    }

    .updateinput {
        font-size: 3em;
        text-align: left;
        width: 300px;
        border: solid thin #888888;
    }

    .wd {
        width: 100%;
        max-width: 500px;
    }

    .fakelist {
        margin-left: 5px;
        margin-right: 5px;
        padding: 8px;
        font-size: 1em;
        width: 100%;
    }

    .bottomnav {
        position: fixed;
        z-index: 3;
        height: 56px;
        width: 100%;
        bottom: 0;
        left: 0;
        text-align: center;
    }

    .bottomnav button {
        color: #FFFFFF;
    }

    .bd {
        border: solid thin #888888;
    }
</style>